import Cookies from "js-cookie";
import {
  GET_PROMPTS_URL,
  GET_PROMPT_URL,
  UPDATE_PROMPT_URL,
  CREATE_PROMPT_URL,
  DELETE_PROMPT_URL,
} from "../apiurls/apiurls";

const getAuthToken = () => {
  return Cookies.get("admin_token");
};

const getHeaders = () => {
  const headers = { "Content-Type": "application/json" };
  const token = getAuthToken();
  if (token) {
    headers["Authorization"] = ` ${token}`;
  }
  return headers;
};

export const getPrompts = async (type) => {
  const params = new URLSearchParams();
  if (type) {
    params.append("types", type);
  } else {
    params.append("types", "ai_tutor");
    params.append("types", "analysis_validation");
  }

  const response = await fetch(`${GET_PROMPTS_URL}?${params.toString()}`, {
    method: "GET",
    headers: getHeaders(),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();
  if (data && Array.isArray(data.data)) return data.data;
  return Array.isArray(data) ? data : data ? [data] : [];
};

export const getPromptById = async (id) => {
  if (!id) {
    throw new Error("Prompt id is required");
  }

  const params = new URLSearchParams();
  params.append("id", id);

  const response = await fetch(`${GET_PROMPT_URL}?${params.toString()}`, {
    method: "GET",
    headers: getHeaders(),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();
  return data;
};

export const updatePrompt = async (id, payload) => {
  if (!id) {
    throw new Error("Prompt id is required for update");
  }

  const params = new URLSearchParams();
  params.append("id", id);

  const response = await fetch(`${UPDATE_PROMPT_URL}?${params.toString()}`, {
    method: "PUT",
    headers: getHeaders(),
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};

export const createPrompt = async (payload) => {
  const response = await fetch(CREATE_PROMPT_URL, {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};

export const deletePrompt = async (id) => {
  if (!id) {
    throw new Error("Prompt id is required for delete");
  }

  const params = new URLSearchParams();
  params.append("id", id);

  const response = await fetch(`${DELETE_PROMPT_URL}?${params.toString()}`, {
    method: "DELETE",
    headers: getHeaders(),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};
